import React, { useState, useRef, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Modal, Form, Button } from "react-bootstrap";

const QuestionDialog = (props) => {
    const {
        onClose,
        value: valueProp,
        ansValue: ansValueProp,
        open,
        playerList,
        ...other
    } = props;
    const [value, setValue] = React.useState(valueProp);
    const [value1, setValue1] = useState(ansValueProp);

    React.useEffect(() => {
        if (!open) {
            setValue(valueProp);
            setValue1(ansValueProp);
        }
    }, [valueProp, ansValueProp, open]);

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(value, value1);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };
    const handleChange1 = (event) => {
        setValue1(event.target.value);
    };
    return (
        <Dialog
            sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
            maxWidth="xs"
            open={open}
            {...other}
        >
            <DialogTitle>Secert Question </DialogTitle>
            <DialogContent dividers>
                <FormControl style={{ width: "100%" }}>
                    <InputLabel id="demo-simple-select-helper-label">
                        Secert Question
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={value}
                        label="Secert Question"
                        onChange={handleChange}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {playerList.map((option) => (
                            <MenuItem value={option.question}>{option.question}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="outlined-basic"
                        label="Personal Answer"
                        variant="outlined"
                        value={value1}
                        onChange={handleChange1}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    Cancel
                </Button>
                <Button onClick={handleOk}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default QuestionDialog